import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/(legal)/terms-of-use/page.tsx");
